import React from "react";

/**
 * BoostF logo — inline SVG rebuild of the uploaded mark so it has a
 * transparent background and adapts cleanly to light and dark surfaces.
 *
 * variant="light" (default) — emerald bars + charcoal wordmark, use on light bg
 * variant="dark"            — pure white, use on dark bg
 */
const Logo = ({ variant = "light", className = "", height = 32 }) => {
  const isDark = variant === "dark";
  const barMid = isDark ? "#ffffff" : "#0f172a"; // charcoal on light
  const barPeak = isDark ? "#ffffff" : "#65a30d"; // lime on light
  const barBase = isDark ? "#ffffff" : "#059669"; // emerald on light
  const trend = isDark ? "#ffffff" : "#0f172a";
  const word = isDark ? "#ffffff" : "#0f172a";

  return (
    <span
      className={`inline-flex items-center select-none ${className}`}
      aria-label="BoostF"
      role="img"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 220 64"
        height={height}
        width={height * (220 / 64)}
        fill="none"
        style={{ display: "block" }}
      >
        {/* Bars */}
        <g>
          <rect x="4" y="38" width="8" height="22" rx="1.5" fill={barBase} />
          <rect x="16" y="30" width="8" height="30" rx="1.5" fill={barBase} />
          <rect x="28" y="20" width="8" height="40" rx="1.5" fill={barMid} />
          <rect x="40" y="10" width="8" height="50" rx="1.5" fill={barPeak} />
        </g>

        {/* Trend line + dots above the bars */}
        <g stroke={trend} strokeWidth="1.6" strokeLinecap="round" fill="none">
          <path d="M8 30 L20 22 L32 14 L44 6" opacity="0.9" />
        </g>
        <g fill={trend}>
          <circle cx="8" cy="30" r="2.4" />
          <circle cx="20" cy="22" r="2.4" />
          <circle cx="32" cy="14" r="2.4" />
          <circle cx="44" cy="6" r="2.4" />
        </g>

        {/* Wordmark: BoostF */}
        <text
          x="62"
          y="46"
          fill={word}
          fontFamily="Manrope, Inter, ui-sans-serif, system-ui, sans-serif"
          fontWeight="800"
          fontSize="30"
          letterSpacing="-1.2"
        >
          Boost
          <tspan fill={isDark ? "#ffffff" : "#059669"}>F</tspan>
        </text>
      </svg>
    </span>
  );
};

export default Logo;
